// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useCallback, useEffect, useState } from 'react'
import './ResetPassword.scss'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { ResetPassword as ResetPasswordUI, PageLoadingSpinner, ErrorAlert, useAdjustPageHeadEntities } from 'ui_kit_qmd'
import { clear500Error } from '../../store/auth/AuthActions'
import { reset } from '../../store/reset-password/ResetPasswordActions'
import {
  createPasswordForNewMember,
  resendForgotPassword,
  updatePassword,
} from '../../store/reset-password/ResetPasswordThunk'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import { validateEmail } from '../../utils/common'
import errorIcon from '../../images/common/error-icon.svg'
import { ProviderPage } from '../../components/provider-page/ProviderPage'
import { QUICK_MD_TITLE_TEXT } from '../../utils/constants'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export default function ResetPassword({ type }) {
  const params = new URLSearchParams(window.location.search)
  const token = params.get('token')
  const [confirmValue, setConfirmValue] = useState('')
  const [passwordValue, setPasswordValue] = useState('')
  const [emailValue, setEmailValue] = useState('')
  const [isPasswordError, setPasswordError] = useState(false)
  const [isConfirmPasswordError, setIsConfirmPasswordError] = useState(false)
  const [passwordErrorValue, setPasswordErrorValue] = useState('')
  const [confirmPasswordErrorValue, setConfirmPasswordErrorValue] = useState('')
  const [toastErrorMessage, setToastErrorMessage] = useState('')
  const [emailError, setEmailError] = useState(false)
  const [checkerStarted, setCheckerStarted] = useState(false)
  const [isPasswordValid, setPasswordValid] = useState(false)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const loading = useSelector((state) => state.resetPassword.loading)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const success = useSelector((state) => state.resetPassword.success)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const error = useSelector((state) => state.resetPassword.error)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const tokenExpired = useSelector((state) => state.resetPassword.tokenExpired)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const emailSentSuccess = useSelector((state) => state.resetPassword.emailSentSuccess)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const emailToVerify = useSelector((state) => state.resetPassword.emailToVerify)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const loginSuccess = useSelector((state) => state.auth.accessToken)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const isNetworkError = useSelector((state) => state.auth.isNetworkError)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const verifyEmailTitle = tokenExpired ? 'Link Expired' : 'Create Password'
  const resetPasswordTitle = tokenExpired ? 'Link Expired' : 'Reset Password'
  const pageTitle = type === 'verifyEmail' ? verifyEmailTitle : resetPasswordTitle
  const pageHeader = useAdjustPageHeadEntities({
    title: loading ? QUICK_MD_TITLE_TEXT : pageTitle,
  })
  useEffect(
    () => () => {
      document.title = QUICK_MD_TITLE_TEXT
    },
    [],
  )

  const onSubmitPassword = useCallback(() => {
    if (success || emailSentSuccess) {
      navigate('/')
      dispatch(reset())
      return
    }

    setPasswordError(false)
    setIsConfirmPasswordError(false)
    setPasswordErrorValue('')
    setConfirmPasswordErrorValue('')

    if (!passwordValue || !confirmValue) {
      if (!passwordValue) {
        setPasswordError(true)
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        setPasswordErrorValue(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Password'))
      }

      if (!confirmValue) {
        setIsConfirmPasswordError(true)
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        setConfirmPasswordErrorValue(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Confirm password'))
      }
      setToastErrorMessage(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS))
      return
    }
    if (!isPasswordValid) {
      setPasswordError(true)
      setIsConfirmPasswordError(true)
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setPasswordErrorValue(getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'password'))
      setToastErrorMessage(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS))
      if (!checkerStarted) {
        setCheckerStarted(true)
      }
      return
    }
    if (passwordValue !== confirmValue) {
      setPasswordError(true)
      setIsConfirmPasswordError(true)
      setConfirmPasswordErrorValue(getUserFriendlyErrorMessage(errorCodes.PASSWORDS_DO_NOT_MATCH))
      setToastErrorMessage(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS))
      if (!checkerStarted) {
        setCheckerStarted(true)
      }
      return
    }
    setPasswordErrorValue('')
    setConfirmPasswordErrorValue('')
    setPasswordError(false)
    setIsConfirmPasswordError(false)

    if (type === 'verifyEmail') {
      dispatch(createPasswordForNewMember({ Password: passwordValue, Token: token }))
    } else if (type === 'resetPassword') {
      dispatch(updatePassword({ Password: passwordValue, Token: token }))
    }
  }, [
    checkerStarted,
    confirmValue,
    dispatch,
    emailSentSuccess,
    isPasswordValid,
    navigate,
    passwordValue,
    success,
    token,
    type,
  ])

  useEffect(() => {
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const handleEnterPressEvent = (e) => {
      if (e.key === 'Enter') {
        onSubmitPassword()
      }
    }
    window.addEventListener('keyup', handleEnterPressEvent)
    return () => window.removeEventListener('keyup', handleEnterPressEvent)
  }, [passwordValue, confirmValue])

  useEffect(() => {
    if (loginSuccess && type !== 'verifyEmail') {
      navigate('/management')
    }
  }, [loginSuccess])
  useEffect(() => {
    if (isNetworkError) {
      setTimeout(() => {
        dispatch(clear500Error())
      }, 3500)
    }
  }, [isNetworkError])
  useEffect(() => {
    if (error === getUserFriendlyErrorMessage(errorCodes.PASSWORD_MUST_BE_DIFFERENT)) {
      setPasswordErrorValue(error)
      setIsConfirmPasswordError(true)
      setToastErrorMessage(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS))
    }
  }, [error])

  useEffect(() => {
    if (toastErrorMessage) {
      setTimeout(() => {
        setToastErrorMessage('')
      }, 3500)
    }
  }, [toastErrorMessage])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSetConfirmPassword = useCallback((value) => {
    setConfirmValue(value)
    setIsConfirmPasswordError(false)
    setConfirmPasswordErrorValue('')
  }, [])
  const onSetPassword = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      setPasswordValue(value)
      setPasswordError(false)
      setPasswordErrorValue('')
      if (confirmPasswordErrorValue === getUserFriendlyErrorMessage(errorCodes.PASSWORDS_DO_NOT_MATCH)) {
        setConfirmPasswordErrorValue('')
      }
    },
    [confirmPasswordErrorValue],
  )
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSetEmail = useCallback((value) => {
    setEmailValue(value)
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    setEmailError('')
  }, [])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSetValidPassword = useCallback((value) => {
    setPasswordValid(value)
  }, [])

  const onSubmitEmail = useCallback(() => {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    setEmailError('')
    if (!emailValue) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(setEmailError(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Email')))
    } else if (!validateEmail(emailValue)) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(setEmailError(getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'email')))
    } else {
      dispatch(resendForgotPassword({ Email: emailValue }))
    }
  }, [dispatch, emailValue])

  if (success && type === 'verifyEmail') {
    navigate('/')
  }
  if (error === getUserFriendlyErrorMessage(errorCodes.DEFAULT)) {
    navigate('/serverError')
  }
  return (
    // @ts-expect-error TS2740 -- MIGRATION: not approved, fix when encountered
    <ProviderPage
      isLoginPage
      loading={false}
      render={
        <>
          {pageHeader}
          <ResetPasswordUI
            className='reset-password-container'
            emailSentSuccess={emailSentSuccess}
            emailError={emailError}
            onSetEmail={onSetEmail}
            onSubmitEmail={onSubmitEmail}
            type={type}
            tokenExpired={tokenExpired}
            confirmValue={confirmValue}
            success={success}
            onSetPassword={onSetPassword}
            onSetConfirmPassword={onSetConfirmPassword}
            isPasswordError={isPasswordError}
            isConfirmPasswordError={isConfirmPasswordError}
            passwordErrorValue={passwordErrorValue}
            confirmPasswordErrorValue={confirmPasswordErrorValue}
            onSetValidPassword={onSetValidPassword}
            passwordValue={passwordValue}
            checkerStarted={checkerStarted}
            emailToVerify={emailToVerify}
            loading={loading}
            onSubmitPassword={onSubmitPassword}
          />
          {toastErrorMessage ?
            <ErrorAlert errorImg={errorIcon} imgAlt='errorIcon' errorText={toastErrorMessage} />
          : null}
          {isNetworkError ?
            <ErrorAlert
              errorImg={errorIcon}
              imgAlt='errorIcon'
              errorText={getUserFriendlyErrorMessage(errorCodes.NO_CONNECTION)}
            />
          : null}
          {loading ?
            <PageLoadingSpinner />
          : null}
        </>
      }
    />
  )
}
